// extracted by mini-css-extract-plugin
module.exports = {"camp-B":"B_camp-B__3fgr4"};